import React, { useState, useEffect } from 'react';
import {
    Container, Card, CardContent, Typography, IconButton, Tooltip, Grid, Box, useMediaQuery, useTheme,
    Drawer, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, TextField, Button, CircularProgress,
    FormControlLabel, Checkbox, Snackbar, Alert,
    Divider,
    Fab
} from '@mui/material';
import {
    Settings as SettingsIcon,
    ShowChart as ChartIcon,
    TableChart as TableIcon,
    ContentCopyOutlined,
    PropaneSharp,
    AddCircleOutline
} from '@mui/icons-material';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import { LineChart } from '@mui/x-charts/LineChart';
import Navbar from '../Navbar';
import { UrlApi } from '../../services/apirest';
import '@fontsource/orbitron';
import moment from 'moment';
import AddClientModal from './AddClienteModal';
// LOG EVENTOS
import { logEventos } from "../../services/services";

function Telemetria() {
    const [clientes, setClientes] = useState([]);
    const [mediciones, setMediciones] = useState({});
    const [drawerOpen, setDrawerOpen] = useState(false); // drawer tabla de mediciones
    const [modalOpen, setModalOpen] = useState(false); /// modal para mostrar grafico evolucion niveles
    const [openAddModal, setOpenAddModal] = useState(false); ///modal agregar clientes
    const [medicionesSensor, setMedicionesSensor] = useState([]);
    const [medicionesGrafico, setMedicionesGrafico] = useState([]);

    // ====== Estados para modal de CONFIGURACIÓN ======
    const [configModalOpen, setConfigModalOpen] = useState(false);
    const [alerta1, setAlerta1] = useState(0);
    const [alerta2, setAlerta2] = useState(0);
    const [alerta3, setAlerta3] = useState(0);
    const [sensor1Active, setSensor1Active] = useState(0);
    const [sensor2Active, setSensor2Active] = useState(0);
    const [sensor3Active, setSensor3Active] = useState(0);
    const [lalineaasignada, setLaLineaAsignada] = useState(0);

    // Estados para manejar el "loading" de la tabla , gráfico y panel
    const [drawerLoading, setDrawerLoading] = useState(false);
    const [chartLoading, setChartLoading] = useState(false);
    const [loadingClientes, setLoadingClientes] = useState(false);

    // Estado para saber qué cliente se está usando
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [drawerCliente, setDrawerCliente] = useState(null);

    // Series dinámicas del gráfico (sensor1, sensor3, y la predicción)
    const [chartSeries, setChartSeries] = useState([]);

    // ====== Estados para el Snackbar ======
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('info');

    // Estado para “Copiar / ¡Copiado!”
    const [copied, setCopied] = useState(false);

    // Para mostrar la fecha estimada de alcanzar la alerta2
    const [predictedAlerta2Date, setPredictedAlerta2Date] = useState(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Al montar el componente, obtener la lista de clientes
    useEffect(() => {
        getClientes();
    }, []);

    useEffect(() => {
        logEventos("Telemetria Clientes Granel", "Granel", "Telemetria Tanques Granel", localStorage.getItem("user"))
    }, [])

    // =========================
    //   OBTENER CLIENTES
    // =========================
    const getClientes = async () => {
        try {
            setLoadingClientes(true);
            const response = await fetch(`${UrlApi}/api_telemetria/sensores`, {
                headers: { 'Authorization': localStorage.getItem('token') }
            });
            const data = await response.json();
            setClientes(data);

            // Obtener la última medición de cada cliente
            const medicionesPromises = data.map(cliente =>
                fetch(`${UrlApi}/api_telemetria/ultima?ultima=${cliente.lineaasignada}`, {
                    headers: { 'Authorization': localStorage.getItem('token') }
                }).then(res => res.json())
            );
            const medicionesData = await Promise.all(medicionesPromises);

            const nuevasMediciones = {};
            data.forEach((cliente, index) => {
                nuevasMediciones[cliente.lineaasignada] = medicionesData[index];
            });

            setMediciones(prev => {
                if (JSON.stringify(prev) !== JSON.stringify(nuevasMediciones)) {
                    return nuevasMediciones;
                }
                return prev;
            });

        } catch (error) {
            console.error('Error fetching clientes data:', error);
            setSnackbarMessage('Error cargando la lista de clientes');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setLoadingClientes(false);
        }
    };

    // =========================
    //   OBTENER TODAS LAS MEDICIONES
    // =========================
    const getMediciones = async (telefono) => {
        console.log(`Consultando TODAS las mediciones para el sensor (telefono): ${telefono}...`);
        try {
            const response = await fetch(`${UrlApi}/api_telemetria?parametro=${telefono}`, {
                headers: { 'Authorization': localStorage.getItem('token') }
            });
            const data = await response.json();

            console.log(`Respuesta de la API para ${telefono}:`, data);

            setMediciones(prev => ({
                ...prev,
                [telefono]: data
            }));

            return data;
        } catch (error) {
            console.error(`Error fetching telemetria data para ${telefono}:`, error);
            setSnackbarMessage(`Error al obtener mediciones de ${telefono}`);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);

            return [];
        }
    };

    // =========================
    //   ABRIR LA TABLA (Drawer)
    // =========================
    const handleOpenDrawer = async (cliente) => {
        setDrawerCliente(cliente);
        setDrawerOpen(true);
        setDrawerLoading(true);
        const data = await getMediciones(cliente.lineaasignada);
        setMedicionesSensor(data || []);
        setDrawerLoading(false);
    };

    const handleCloseDrawer = () => {
        setDrawerOpen(false);
    };

    const handleOpenAddModal = () => {
        //setOpenAddModal(true);   // modal agregar clientes
    };

    const handleCloseAddModal = () => {
        setOpenAddModal(false);  // modal agregar clientes
    };

    // =========================
    //   REGRESIÓN LINEAL
    // =========================
    function linearRegression(data) {
        const n = data.length;
        if (n < 2) return null;

        let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0;
        data.forEach(({ x, y }) => {
            sumX += x;
            sumY += y;
            sumXY += x * y;
            sumX2 += x * x;
        });

        const meanX = sumX / n;
        const meanY = sumY / n;

        const numerator = sumXY - (sumX * sumY) / n;
        const denominator = sumX2 - (sumX * sumX) / n;
        if (denominator === 0) return null;

        const m = numerator / denominator;
        const b = meanY - m * meanX;
        return { m, b };
    }

    function predictTimeForValue(m, b, valor) {
        if (!m || m === 0) return null;
        const xPred = (valor - b) / m;
        return xPred;
    }

    function generatePredictionLine(m, b, xMin, xMax, steps = 10) {
        const step = (xMax - xMin) / (steps - 1);
        const result = [];
        for (let i = 0; i < steps; i++) {
            const xVal = xMin + step * i;
            const yVal = m * xVal + b;
            result.push({ x: xVal, y: yVal });
        }
        return result;
    }

    // =========================
    //   ABRIR EL GRÁFICO (Modal)
    // =========================
    // Solo muestro la parte clave de handleOpenModalGrafico con logs:
    // (Dentro de tu componente Telemetria)

    async function handleOpenModalGrafico(cliente) {
        console.log("// DEBUG: ABRIENDO GRAFICO PARA:", cliente.cliente);

        // Limpia la predicción anterior (por si se abre un gráfico de otro cliente)
        setPredictedAlerta2Date(null);

        // Asigna el cliente seleccionado (para la leyenda, etc.)
        setClienteSeleccionado(cliente);

        // Construir series base (sensor1, sensor3, prediccion)
        const seriesArray = [];
        if (cliente.sensor1 === 1) {
            seriesArray.push({
                dataKey: 'sensor1',
                label: 'Sensor 1 (%)',
                color: '#FF00CC',
                curve: 'linear',
                showMark: true,
            });
        }
        if (cliente.sensor3 === 1) {
            seriesArray.push({
                dataKey: 'sensor3',
                label: 'Sensor 3 (%)',
                color: '#00bcd4',
                curve: 'linear',
                showMark: true,
            });
        }
        // Serie para predicción
        seriesArray.push({
            dataKey: 'prediccion',
            label: 'Predicción',
            color: 'orange',
            curve: 'linear',
            showMark: true,
            dashed: true, // si quieres que sea punteada
        });

        setChartSeries(seriesArray);

        // Abre el modal y activa "cargando"
        setModalOpen(true);
        setChartLoading(true);

        console.log("// DEBUG: Buscando mediciones para:", cliente.lineaasignada);
        const datosGrafico = await getMediciones(cliente.lineaasignada);

        console.log("// DEBUG: datosGrafico length:", datosGrafico.length);

        // 1. Transformar y ordenar
        const datosTransformados = datosGrafico.map((medicion) => {
            const fechaUTC = new Date(medicion.medicion);
            const fechaLocal = new Date(fechaUTC.getTime() - fechaUTC.getTimezoneOffset() * 60000);
            return {
                ...medicion,
                sensor1: parseFloat(medicion.sensor1),
                sensor3: parseFloat(medicion.sensor3),
                fecha: fechaLocal.getTime(),
            };
        });
        const datosOrdenados = datosTransformados.sort((a, b) => a.fecha - b.fecha);
        console.log("// DEBUG: datosOrdenados length:", datosOrdenados.length);

        // 2. Crear datasetConPrediccion (copiando real, prediccion = null)
        let datasetConPrediccion = datosOrdenados.map(d => ({
            fecha: d.fecha,
            sensor1: d.sensor1,
            sensor3: d.sensor3,
            prediccion: null,
        }));

        let fechaEstimadaAlerta2 = null;

        // 3. Calcular la regresión lineal para sensor3 si hay suficientes datos
        if (cliente.sensor3 === 1 && datosOrdenados.length > 1) {
            console.log("// DEBUG: Calculando regresion lineal para sensor3");
            const a2Local = cliente.alerta2 ?? 40;

            // Toma todos los puntos para la regresión (o los últimos N si quieres)
            const dataForRegression = datosOrdenados.map(d => ({ x: d.fecha, y: d.sensor3 }));
            const lr = linearRegression(dataForRegression);

            if (lr) {
                let { m, b } = lr;
                console.log("// DEBUG: Regresion => m:", m, " b:", b);

                // 3.1. Si la pendiente (m) > 0 => forzamos a 0 (línea horizontal)
                if (m > 0) {
                    m = 0;
                    // Ajustamos b al último valor real
                    const lastVal = datasetConPrediccion[datasetConPrediccion.length - 1].sensor3;
                    b = lastVal;
                    console.log("// DEBUG: Forzando pendiente a 0, b=", b);
                }

                // 3.2. Rango real
                const xMax = datosOrdenados[datosOrdenados.length - 1].fecha;

                // 3.3. Punto de transición => en el último objeto real, prediccion = sensor3
                if (datasetConPrediccion.length > 0) {
                    const lastIndex = datasetConPrediccion.length - 1;
                    datasetConPrediccion[lastIndex].prediccion = datasetConPrediccion[lastIndex].sensor3;
                }

                // 3.4. Generar la línea de predicción más allá del último real
                const xMaxFuturo = xMax + (15 * 24 * 60 * 60 * 1000); // +15 días de proyección
                const predictedPoints = generatePredictionLine(m, b, xMax, xMaxFuturo, 5);

                // 3.5. Convertir predictedPoints a { fecha, sensor1:null, sensor3:null, prediccion:y }
                const predictedData = predictedPoints.map(pt => ({
                    fecha: pt.x,
                    sensor1: null,
                    sensor3: null,
                    prediccion: pt.y,
                }));

                // 3.6. Unir y ordenar
                datasetConPrediccion = datasetConPrediccion.concat(predictedData);
                datasetConPrediccion.sort((a, b) => a.fecha - b.fecha);

                // 3.7. Calcular xPred para a2Local => solo si la pendiente <= 0?
                if (m !== 0 && a2Local > 0) {
                    // OJO: Si m=0, xPred no se definirá
                    const xPred = predictTimeForValue(m, b, a2Local);
                    if (xPred && xPred > xMax) {
                        fechaEstimadaAlerta2 = new Date(xPred);
                    }
                }
            } else {
                console.log("// DEBUG: regresion lineal => null (sin datos o slope=0 con denominador=0)");
            }
        } else {
            console.log("// DEBUG: No sensor3 activo o pocos datos para regresion");
        }

        console.log("// DEBUG: datasetConPrediccion final =>", datasetConPrediccion);
        console.log("// DEBUG: fechaEstimadaAlerta2 =>", fechaEstimadaAlerta2);

        // 4. Guardar en el estado
        setMedicionesGrafico(datasetConPrediccion);
        setPredictedAlerta2Date(fechaEstimadaAlerta2);

        // Desactiva "cargando"
        setChartLoading(false);
    }


    /////////////////////////Fechas
    function parseFechaCompleta(fechaCompleta) {
        // Ejemplo de fechaCompleta: "12/03/2025 13:00:00"
        const [fechaStr, horaStr] = fechaCompleta.split(' '); // ["12/03/2025", "13:00:00"]
        const [dia, mes, anio] = fechaStr.split('/');         // ["12", "03", "2025"]
        const [h, min, seg] = horaStr.split(':');             // ["13", "00", "00"]

        return new Date(
            Number(anio),
            Number(mes) - 1,  // meses en JS van de 0 a 11
            Number(dia),
            Number(h),
            Number(min),
            Number(seg)
        );
    }

    // 1. Define un estilo "blinking" con keyframes
    const blinkingStyle = {
        color: 'red',
        fontWeight: 'bold',      // para texto en negrita
        animation: 'blinkAnimation 1s infinite', // 1s, repetición infinita
        // Definimos los keyframes dentro del objeto sx:
        '@keyframes blinkAnimation': {
            '0%': { opacity: 1 },
            '50%': { opacity: 0 },
            '100%': { opacity: 1 },
        },
    };

    const handleCloseModalGrafico = () => {
        setModalOpen(false);
        setPredictedAlerta2Date(null);
    };

    // =========================
    //   ABRIR EL MODAL DE CONFIG
    // =========================
    const handleOpenConfigModal = (cliente) => {
        setClienteSeleccionado(cliente);
        setAlerta1(cliente.alerta1 || 20);
        setAlerta2(cliente.alerta2 || 40);
        setAlerta3(cliente.alerta3 || 60);
        setSensor1Active(cliente.sensor1 || 0);
        setSensor2Active(cliente.sensor2 || 0);
        setSensor3Active(cliente.sensor3 || 0);
        setLaLineaAsignada(cliente.lineaasignada);
        setConfigModalOpen(true);
    };

    const handleCloseConfigModal = () => {
        setConfigModalOpen(false);
    };

    // =========================
    //   GUARDAR CONFIG
    // =========================
    const handleSaveConfig = async () => {
        const updateData = {
            alerta1,
            alerta2,
            alerta3,
            sensor1: sensor1Active,
            sensor2: sensor2Active,
            sensor3: sensor3Active,
            lineaasignada: lalineaasignada,
            usuario: localStorage.getItem("user")
        };

        try {
            if (!clienteSeleccionado) return;
            const response = await fetch(`${UrlApi}/api_telemetria/sensorparams/${clienteSeleccionado.idsensores}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token'),
                },
                body: JSON.stringify(updateData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                setSnackbarMessage(`Ocurrió un error: ${errorData.error || 'desconocido'}`);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                return;
            }

            setSnackbarMessage('Configuracion actualizada !');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);

            setConfigModalOpen(false);
            await getClientes();
        } catch (error) {
            setSnackbarMessage('No se pudo actualizar la configuracion. Consultar con sistemas.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    };

    // =========================
    //   FUNCIONES AUXILIARES
    // =========================
    function getColorByPercentage(percentage, a1, a2, a3) {
        if (percentage < a1) return 'red';
        if (percentage >= a1 && percentage < a2) return 'orange';
        if (percentage >= a2 && percentage < a3) return 'green';
        return 'violet';
    }

    const getBatteryColor = (voltage) => {
        return voltage >= 3.55 ? 'green' : 'red';
    };

    function isFechaMenorADosDias(fechaStr) {
        const fechaMedicion = parseFechaCompleta(fechaStr);
        const hoy = new Date();
        const dosDiasEnMs = 2 * 24 * 60 * 60 * 1000;
        return (hoy - fechaMedicion) > dosDiasEnMs;
    }


    const separarFechaYHora = (fechaCompleta) => {
        const [fecha, hora] = fechaCompleta.split(' ');
        return { fecha, hora };
    };

    // Copiar contenido de la tabla
    const handleCopyTable = () => {
        let text = 'Fecha,Hora';
        if (drawerCliente?.sensor1 === 1) text += ',S1 (%)';
        if (drawerCliente?.sensor3 === 1) text += ',S3 (%)';
        text += ',Bateria (v)\n';

        medicionesSensor.forEach((m) => {
            const { fecha, hora } = separarFechaYHora(m.fecha);
            text += `${fecha},${hora}`;
            if (drawerCliente?.sensor1 === 1) text += `,${m.sensor1 ?? ''}`;
            if (drawerCliente?.sensor3 === 1) text += `,${m.sensor3 ?? ''}`;
            text += `,${m.battlevel ?? ''}\n`;
        });

        navigator.clipboard.writeText(text)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch((err) => {
                console.error('Error al copiar:', err);
            });
    };

    // Llamado cuando el modal termina de crear un cliente
    const handleAddClientSuccess = () => {
        getClientes();
    };

    return (
        <div>
            <Navbar />
            <Container sx={{ pt: '20px', marginLeft: '5px', marginRight: '5px' }}>
                {/* Contenedor para el título y el ícono */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 2, // margen inferior
                    }}
                >
                    {/* Título con tipografía MUI */}
                    <Typography
                        variant="h5"
                        sx={{
                            color: '#000000',
                            fontFamily: 'Verdana' // o la que prefieras
                        }}
                    >
                        Telemetría - Clientes
                    </Typography>

                    {/* Botón o ícono a la derecha */}

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddCircleOutline />}
                        onClick={handleOpenAddModal}
                    >
                        Nuevo Cliente
                    </Button>

                </Box>

                {loadingClientes ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                        <CircularProgress color="inherit" />
                    </Box>
                ) : (
                    <Grid container spacing={3}>
                        {console.log(clientes)}
                        {clientes.length > 0 ? (
                            clientes.map((cliente) => {
                                const ultimaMedicionArr = mediciones[cliente.lineaasignada] || [];
                                const ultimaMedicion = ultimaMedicionArr[0];
                                const porcentajeSensor3 = ultimaMedicion ? ultimaMedicion.sensor3 : 0;
                                const a1 = cliente.alerta1 ?? 20;
                                const a2 = cliente.alerta2 ?? 40;
                                const a3 = cliente.alerta3 ?? 60;
                                const colorSensor3 = getColorByPercentage(porcentajeSensor3, a1, a2, a3);

                                const porcentajeSensor1 = ultimaMedicion ? ultimaMedicion.sensor1 : 0;
                                const colorSensor1 = getColorByPercentage(porcentajeSensor1, a1, a2, a3);

                                //const batteryColor = ultimaMedicion ? getBatteryColor(ultimaMedicion.battlevel) : 'gray';
                                const { fecha, hora } = ultimaMedicion
                                    ? separarFechaYHora(ultimaMedicion.fecha)
                                    : { fecha: '', hora: '' };

                                const fechaEsMenorADosDias = ultimaMedicion
                                    ? isFechaMenorADosDias(ultimaMedicion.fecha)
                                    : false;

                                const fechaMoment = moment(ultimaMedicion.fecha, 'DD/MM/YYYY HH:mm:ss');
                                const diffHoras = moment().diff(fechaMoment, 'hours');

                                let tiempoPasado;
                                if (diffHoras < 24) {
                                    tiempoPasado = `hace ${diffHoras} hora${diffHoras !== 1 ? 's' : ''}`;
                                } else {
                                    const diffDias = Math.floor(diffHoras / 24);
                                    tiempoPasado = `hace ${diffDias} día${diffDias !== 1 ? 's' : ''}`;
                                }
                                return (
                                    <Grid item xs={12} sm={6} key={cliente.cliente}>
                                        <Card
                                            sx={{
                                                marginBottom: '20px',
                                                borderLeft: `5px solid ${fechaEsMenorADosDias ? 'red' : colorSensor3}`,
                                                backgroundColor: '#1e1e1e',
                                                color: '#ffffff',
                                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    background: 'linear-gradient(135deg, #2c3e50, #bdc3c7)',
                                                    p: 1,
                                                    borderTopLeftRadius: '4px',
                                                    borderTopRightRadius: '4px',
                                                }}
                                            >
                                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#ffffff' }}>
                                                    {cliente.cliente}-{cliente.razon_social}
                                                </Typography>
                                                <Typography variant="subtitle1" sx={{ color: '#e0e0e0' }}>
                                                    Lugar: {cliente.nombre_direccion}
                                                </Typography>
                                            </Box>

                                            <CardContent>
                                                {ultimaMedicion ? (
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                        {cliente.sensor1 === 1 && (
                                                            <Grid container spacing={3}>
                                                                <Grid item xs={6}>
                                                                    <Typography
                                                                        variant={isMobile ? 'h3' : 'h2'}
                                                                        sx={{ fontFamily: 'Orbitron, sans-serif', color: colorSensor1, textAlign: 'center' }}
                                                                    >
                                                                        {porcentajeSensor1}%
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <CalendarTodayIcon fontSize="small" style={{ color: '#ffffff' }} />
                                                                            {fechaEsMenorADosDias || porcentajeSensor1 === 0 ? (
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    sx={blinkingStyle} // Si está fuera de fecha, usar blinking
                                                                                >
                                                                                    {fecha} - Revisar equipo
                                                                                </Typography>
                                                                            ) : (
                                                                                <Typography variant="body2" sx={{ color: '#ffffff' }}>
                                                                                    {fecha} — {tiempoPasado}
                                                                                </Typography>
                                                                            )}
                                                                        </Box>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <AccessTimeIcon fontSize="small" style={{ color: '#ffffff' }} />
                                                                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                                                                {hora}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <PropaneSharp fontSize="small" style={{ color: '#ffffff' }} />
                                                                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                                                                Tanque S/N : {cliente.nro_t1} ({cliente.capacidad_tanque1} m3)
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        )}

                                                        {cliente.sensor1 === 1 && cliente.sensor3 === 1 && (
                                                            <Box sx={{ borderBottom: '1px solid #ffffff', my: 2 }} />
                                                        )}

                                                        {cliente.sensor3 === 1 && (
                                                            <Grid container spacing={3}>
                                                                <Grid item xs={6}>
                                                                    <Typography
                                                                        variant={isMobile ? 'h3' : 'h2'}
                                                                        sx={{ fontFamily: 'Orbitron, sans-serif', color: colorSensor3, textAlign: 'center' }}
                                                                    >
                                                                        {porcentajeSensor3}%
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <CalendarTodayIcon fontSize="small" style={{ color: '#ffffff' }} />
                                                                            {fechaEsMenorADosDias || porcentajeSensor3 === 0 ? (
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    sx={blinkingStyle} // Si está fuera de fecha, usar blinking
                                                                                >
                                                                                    {fecha} - Revisar Equipo
                                                                                </Typography>
                                                                            ) : (
                                                                                <Typography variant="body2" sx={{ color: '#ffffff' }}>
                                                                                    {fecha} — {tiempoPasado}
                                                                                </Typography>
                                                                            )}
                                                                        </Box>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <AccessTimeIcon fontSize="small" style={{ color: '#ffffff' }} />
                                                                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                                                                {hora}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <PropaneSharp fontSize="small" style={{ color: '#ffffff' }} />
                                                                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                                                                Tanque S/N : {cliente.nro_t3} ({cliente.capacidad_tanque3} m3)
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Box>
                                                ) : (
                                                    <Typography variant="body2" sx={{ color: '#bbccbb' }}>
                                                        No hay datos de telemetría para este cliente.
                                                        Revisar la linea de telefono asignada o
                                                        el equipo no ha enviado datos aun
                                                    </Typography>
                                                )}
                                            </CardContent>

                                            <Box sx={{ backgroundColor: '#2a2a2a', p: 1, borderTop: '1px solid #444' }}>
                                                <Grid container spacing={1} alignItems="center">
                                                    <Grid item xs={6}>
                                                        {/*                                                         <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                                            Tanque: {cliente.tanque3}
                                                        </Typography> */}
                                                        <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                                            Sensor: {cliente.lineaasignada}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={6}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'flex-end',
                                                            alignItems: 'center',
                                                            gap: .5,
                                                        }}
                                                    >
                                                        {ultimaMedicion && (
                                                            <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                                                <BatteryChargingFullIcon fontSize="small" style={{ color: getBatteryColor(ultimaMedicion.battlevel) }} />
                                                                <Typography variant="body2" sx={{ color: '#b0b0b0', ml: 0.5 }}>
                                                                    {ultimaMedicion.battlevel} v
                                                                </Typography>
                                                            </Box>
                                                        )}
                                                        <Divider
                                                            orientation="vertical"
                                                            flexItem
                                                            sx={{ borderColor: '#999', mx: 1 }} // Ajusta el color, márgenes, etc.
                                                        />
                                                        <Tooltip title="Configuración" arrow>
                                                            <IconButton sx={{ color: '#eb984e' }} onClick={() => handleOpenConfigModal(cliente)}>
                                                                <SettingsIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Evolución" arrow>
                                                            <IconButton sx={{ color: '#00bcd4' }} onClick={() => handleOpenModalGrafico(cliente)}>
                                                                <ChartIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Datos" arrow>
                                                            <IconButton sx={{ color: '#ffeb3b' }} onClick={() => handleOpenDrawer(cliente)}>
                                                                <TableIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Card>
                                    </Grid>
                                );
                            })
                        ) : (
                            <p>No hay clientes con sensores de telemetria...</p>
                        )}
                    </Grid>
                )}

            </Container>

            {/* Drawer para mostrar la tabla de mediciones */}
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleCloseDrawer}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: isMobile ? '90%' : '400px',
                        backgroundColor: '#1e1e1e',
                        color: '#ffffff',
                        marginTop: '56px',
                        height: '80vh',
                        overflow: 'hidden',
                    },
                }}
            >
                <Box
                    sx={{
                        p: 2,
                        borderBottom: '1px solid #444',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <Typography variant="h6" component="h2">
                        Mediciones del Sensor
                    </Typography>
                    <Button
                        onClick={handleCopyTable}
                        variant="text"
                        sx={{ color: '#fff' }}
                        startIcon={<ContentCopyOutlined />}
                    >
                        {copied ? '¡Copiado!' : 'Copiar'}
                    </Button>
                </Box>

                <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    {drawerLoading ? (
                        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress color="inherit" />
                        </Box>
                    ) : (
                        <TableContainer sx={{ flex: 1, overflowX: 'auto', overflowY: 'auto' }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ color: '#ffffff', backgroundColor: '#2c3e50', textAlign: 'left', padding: '8px' }}>Fecha</TableCell>
                                        <TableCell sx={{ color: '#ffffff', backgroundColor: '#2c3e50', textAlign: 'left', padding: '8px' }}>Hora</TableCell>
                                        {drawerCliente?.sensor1 === 1 && (
                                            <TableCell sx={{ color: '#ffffff', backgroundColor: '#2c3e50', textAlign: 'right', padding: '8px' }}>
                                                S1 (%)
                                            </TableCell>
                                        )}
                                        {drawerCliente?.sensor3 === 1 && (
                                            <TableCell sx={{ color: '#ffffff', backgroundColor: '#2c3e50', textAlign: 'right', padding: '8px' }}>
                                                S3 (%)
                                            </TableCell>
                                        )}
                                        <TableCell sx={{ color: '#ffffff', backgroundColor: '#2c3e50', textAlign: 'right', padding: '8px' }}>
                                            Bateria (v)
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {medicionesSensor.map((medicion, index) => {
                                        const { fecha, hora } = separarFechaYHora(medicion.fecha);
                                        return (
                                            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell sx={{ color: '#ffffff', textAlign: 'left', padding: '8px', borderBottom: '1px solid #444' }}>
                                                    {fecha}
                                                </TableCell>
                                                <TableCell sx={{ color: '#ffffff', textAlign: 'left', padding: '8px', borderBottom: '1px solid #444' }}>
                                                    {hora}
                                                </TableCell>
                                                {drawerCliente?.sensor1 === 1 && (
                                                    <TableCell sx={{ color: '#ffffff', textAlign: 'right', padding: '8px', borderBottom: '1px solid #444' }}>
                                                        {medicion.sensor1}
                                                    </TableCell>
                                                )}
                                                {drawerCliente?.sensor3 === 1 && (
                                                    <TableCell sx={{ color: '#ffffff', textAlign: 'right', padding: '8px', borderBottom: '1px solid #444' }}>
                                                        {medicion.sensor3}
                                                    </TableCell>
                                                )}
                                                <TableCell sx={{ color: '#ffffff', textAlign: 'right', padding: '8px', borderBottom: '1px solid #444' }}>
                                                    {medicion.battlevel}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </Drawer>

            {/* Modal para mostrar el gráfico de evolución */}
            <Modal
                open={modalOpen}
                onClose={handleCloseModalGrafico}
                aria-labelledby="modal-grafico-title"
                aria-describedby="modal-grafico-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isMobile ? '90%' : '600px',
                        bgcolor: '#1e1e1e',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '4px',
                        color: '#ffffff',
                    }}
                >
                    {chartLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
                            <CircularProgress color="inherit" />
                        </Box>
                    ) : (
                        <>
                            <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                                Evolución Diaria del Nivel
                            </Typography>

                            {!predictedAlerta2Date ? (
                                <Typography sx={{ color: 'orange' }}>
                                    No se alcanzará la alerta2 en el rango previsto
                                </Typography>
                            ) : (
                                <Typography sx={{ color: 'orange' }}>
                                    Se estima que se alcanzará la alerta2 ({clienteSeleccionado.alerta2}%)
                                    el: {predictedAlerta2Date.toLocaleString()}
                                </Typography>
                            )}


                            <LineChart
                                xAxis={[{
                                    dataKey: 'fecha',
                                    scaleType: 'time',
                                    valueFormatter: (timestamp) => {
                                        if (!timestamp) return "";
                                        const fecha = new Date(timestamp);
                                        const dia = String(fecha.getDate()).padStart(2, '0');
                                        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
                                        const año = fecha.getFullYear();
                                        return `${dia}/${mes}/${año}`;
                                    },
                                    tickValues: medicionesGrafico.map(m => m.fecha),
                                }]}
                                yAxis={[{
                                    scaleType: 'linear',
                                    min: 0,
                                    max: 100,
                                }]}
                                series={chartSeries}
                                dataset={medicionesGrafico.length > 0 ? medicionesGrafico : [{ fecha: Date.now(), sensor3: 0 }]}
                                height={400}
                                margin={{ left: 70, right: 20, top: 20, bottom: 50 }}
                                sx={{
                                    '& .MuiChartsAxis-line, & .MuiChartsAxis-tickLabel': { stroke: '#000000' },
                                    '& .MuiChartsAxis-tick': { stroke: '#000000' },
                                    '& .MuiChartsGrid-line': { stroke: '#444' },
                                    '& .MuiLineElement-root': { strokeWidth: 2 },
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '10px',
                                }}
                            />
                        </>
                    )}
                </Box>
            </Modal>

            {/* Modal de Configuración */}
            <Modal
                open={configModalOpen}
                onClose={handleCloseConfigModal}
                aria-labelledby="modal-config-title"
                aria-describedby="modal-config-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isMobile ? '90%' : '400px',
                        bgcolor: '#ffffff',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '4px',
                        color: '#000000',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    }}
                >
                    <Typography variant="body1" component="h2" id="modal-config-title">
                        Configurar Alertas y Sensores Activos del cliente : {clienteSeleccionado?.razon_social + '-' + clienteSeleccionado?.nombre_direccion || '...'}
                    </Typography>

                    <Typography variant="h6" id="modal-config-description" sx={{ pl: '5px', color: 'white', background: 'black' }}>
                        Linea telefónica asignada
                    </Typography>
                    <TextField
                        label="Linea telefonica (ej: 5493412223333)"
                        type="number"
                        variant="outlined"
                        fullWidth
                        value={lalineaasignada}
                        onChange={(e) => setLaLineaAsignada(e.target.value)}
                        InputProps={{ style: { color: '#000000' } }}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: 'blue' } } }}
                    />
                    <Typography variant="h6" id="modal-config-description" sx={{ pl: '5px', color: 'white', background: 'black' }}>
                        Ajustar los porcentajes de alertas
                    </Typography>
                    <TextField
                        label="Nivel minimo, Rojo y avisa por mensaje (%)"
                        type="number"
                        variant="outlined"
                        fullWidth
                        value={alerta1}
                        onChange={(e) => setAlerta1(e.target.value)}
                        InputProps={{ style: { color: '#000000' } }}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: 'blue' } } }}
                    />
                    <TextField
                        label="Nivel alerta, menor se muestra en Naranja, mayor en Verde (%)"
                        type="number"
                        variant="outlined"
                        fullWidth
                        value={alerta2}
                        onChange={(e) => setAlerta2(e.target.value)}
                        InputProps={{ style: { color: '#000000' } }}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: 'blue' } } }}
                    />
                    <TextField
                        label="Sobrellenado (%)"
                        type="number"
                        variant="outlined"
                        fullWidth
                        value={alerta3}
                        onChange={(e) => setAlerta3(e.target.value)}
                        InputProps={{ style: { color: '#000000' } }}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: 'blue' } } }}
                    />

                    <Typography variant="h6" id="modal-config-description" sx={{ pl: '5px', color: 'white', background: 'black' }}>
                        Tildar sensores conectados en equipo
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sensor1Active === 1}
                                onChange={(e) => setSensor1Active(e.target.checked ? 1 : 0)}
                                sx={{
                                    color: sensor1Active === 1 ? 'green' : 'red',
                                    '&.Mui-checked': {
                                        color: sensor1Active === 1 ? 'green' : 'red',
                                    },
                                }}
                            />
                        }
                        label={
                            <Typography sx={{ color: sensor1Active === 1 ? 'green' : 'red' }}>
                                {sensor1Active === 1 ? 'Sensor 1 Conectado' : 'Sensor 1 Desconectado'}
                            </Typography>
                        }
                    />

                    {/* Sensor 2 (opcional) */}
                    {/* 
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sensor2Active === 1}
                                onChange={(e) => setSensor2Active(e.target.checked ? 1 : 0)}
                                sx={{ color: '#ffffff' }}
                            />
                        }
                        label="Sensor 2 Conectado"
                    /> 
                    */}

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sensor3Active === 1}
                                onChange={(e) => setSensor3Active(e.target.checked ? 1 : 0)}
                                sx={{
                                    color: sensor3Active === 1 ? 'green' : 'red',
                                    '&.Mui-checked': {
                                        color: sensor3Active === 1 ? 'green' : 'red',
                                    },
                                }}
                            />
                        }
                        label={
                            <Typography sx={{ color: sensor3Active === 1 ? 'green' : 'red' }}>
                                {sensor3Active === 1 ? 'Sensor 3 Conectado' : 'Sensor 3 Desconectado'}
                            </Typography>
                        }
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                        <Button variant="contained" color="secondary" onClick={handleCloseConfigModal}>
                            Cancelar
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSaveConfig}>
                            Guardar
                        </Button>
                    </Box>
                </Box>
            </Modal>

            {/* Modal para agregar un nuevo cliente */}
            <AddClientModal
                open={openAddModal}
                onClose={handleCloseAddModal}
                onSuccess={handleAddClientSuccess} // para refrescar la lista
            />

            {/* ====== SNACKBAR ====== */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{
                    '&.MuiSnackbar-root': {
                        top: '80px !important',
                        right: '30px !important',
                    },
                }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    sx={{
                        backgroundColor: 'blue',
                        color: '#fff',
                        fontWeight: 'bold',
                    }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default Telemetria;
